import { render } from "./ElectionBallotView.vue?vue&type=template&id=a5629458"
import script from "./ElectionBallotView.vue?vue&type=script&lang=js"
export * from "./ElectionBallotView.vue?vue&type=script&lang=js"

import "./ElectionBallotView.vue?vue&type=style&index=0&id=a5629458&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__